import React from "react";
import HotspotIcon from "../icon/HotspotIcon";
import useTranslation from "../../../../lib/hooks/useTranslation";
import hotspotExplainerClasses from "./ProductHotspotExplainer.module.css";
import hotspotClasses from "../HotspotStyles.module.css";

export default ({ imageSrc }) => {
  const translations = useTranslation();
  return (
    <>
      <div className={hotspotClasses.infoImageContainer}>
        <div className="d-flex">
          <div
            className={`${hotspotExplainerClasses.partition} ${hotspotExplainerClasses.triangleRight} position-relative bg-secondary d-flex justify-content-center align-items-center`}
          >
            <HotspotIcon className="position-relative" />
          </div>
          <div
            style={{
              backgroundImage: `url(${imageSrc})`,
              backgroundPosition: "center",
            }}
            className={`${hotspotExplainerClasses.partition} d-flex justify-content-center align-items-center`}
          >
            <HotspotIcon className="position-relative" isSelected />
          </div>
        </div>
      </div>
      <div className="py-3">
        <p className="font-weight-bold text-primary">
          {translations.hotspot_info_title}
        </p>
        <p>{translations.hotspot_info_description}</p>
      </div>
    </>
  );
};
